import {
  Footer,
  Selectors,
  UserTierTypes,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {FooterContentType} from '@eCommerce/frontend-legacy-shared-library-native/lib/typescript/store/content';
import logoSrc from 'assets/caesars_rewards_light.svg';
import React from 'react';

interface ConnectedMyRewardsFooterProps {
  onFooterItemPress: () => void;
  footerItemHref: () => string;
}

const ConnectedMyRewardsFooter: React.FunctionComponent<
  ConnectedMyRewardsFooterProps
> = ({onFooterItemPress, footerItemHref}) => {
  const footerContent = useWidgetState(Selectors.footerContentSelector) as
    | FooterContentType
    | undefined;
  const footerAuthenticatedContent = useWidgetState(
    Selectors.footerAuthenticatedContentSelector
  ) as FooterContentType | undefined;
  const isAuthenticated = useWidgetState(
    Selectors.isLoggedInSelector
  ) as boolean;
  const currentLevel = useWidgetState(
    Selectors.userExtendedTierCodeSelector
  ) as UserTierTypes;
  const isUserSevenStars = currentLevel === UserTierTypes.SEVEN_STARS;

  return (
    <Footer
      onFooterItemPress={onFooterItemPress}
      footerItemHref={footerItemHref}
      footerContent={
        isAuthenticated ? footerAuthenticatedContent : footerContent
      }
      isUserSevenStars={isUserSevenStars}
      footerLogo={{logoSrc, altText: 'Caesars Rewards Logo'}}
      testIdPrefix={'caesars_rewards'}
    />
  );
};

export default ConnectedMyRewardsFooter;
